const BACKEND_HTTP = 'https';
const BACKEND_PORT = 5001;

function getPort() {
  const port = window.location.port;
  console.log(port);
  return port !== '80' && port !== '443' && port !== '' ? `:${port}` : '';
}

export function getUrlBackLogin() {
  if (window.location.hostname === 'localhost')
    return `${BACKEND_HTTP}://${window.location.hostname}:${BACKEND_PORT}/authenticate/login`;
  else
    return `${window.location.protocol}//${
      window.location.hostname
    }${getPort()}/authenticate/login`;
}

export function getUrlBackApi() {
  if (window.location.hostname === 'localhost')
    return `${BACKEND_HTTP}://${window.location.hostname}:${BACKEND_PORT}/api/`;
  else
    return `${window.location.protocol}//${
      window.location.hostname
    }${getPort()}/api/`;
}

export function getUrlBack() {
  if (window.location.hostname === 'localhost')
    return `${BACKEND_HTTP}://${window.location.hostname}:${BACKEND_PORT}/`;
  else
    return `${window.location.protocol}//${
      window.location.hostname
    }${getPort()}/`;
}
